// import { doctorsListService } from "../../../../components/Shared/DoctorList/doctor-list-service";
import { apiServiceConstants } from "../../../../constants/apiService.constants";
import { apiService } from "../../../../services/apiService";
import { utilService } from "../../../../services/utilService";
// import { FileShareFullListInterface, FileShareFullListModel, FileShareFullListResult, MediaItemForwardModel } from "./SelectUserComponent.model";

const successfullyUploadedList: any = [];
const mediaUploadList: any = [];

const mediaUpload = async (params: any): Promise<any> => {
  const respApiResult = await apiService
    .apiCall(
      `media-share/media-upload/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.POST,
      utilService.getDeviceType()
    )
    .then((res) => {
      const fileShareMediaListResp = res as any;
      const result: any = {
        isSuccess: true,
        status: fileShareMediaListResp.status,
        message: fileShareMediaListResp.message,
      };
      return result;
    })
    .catch((err) => {
      const result: any = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });

  return respApiResult;
};

export const MediaUploadService = {
  mediaUpload,
  successfullyUploadedList,
  mediaUploadList,
};
